import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87a39f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-endpoint-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_viewer = _resolveComponent("pdf-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPdfContent)
      ? (_openBlock(), _createBlock(_component_pdf_viewer, {
          key: 0,
          source: `./pdf/endpoints/${_ctx.endpointData.pdf}.pdf`,
          "pdf-width": parseFloat(_ctx.endpointData.pdfwidth) || 1280,
          "pdf-height": parseFloat(_ctx.endpointData.pdfheight) || 720,
          "go-back-icon": require('!html-loader!@/applications/covid-hub/modules/endpoint/assets/images/home-icon-black.svg')
        }, null, 8, ["source", "pdf-width", "pdf-height", "go-back-icon"]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeTemplate()), { key: 1 }))
  ]))
}